<template lang="pug">
.room-result-wrapper
  .tournament-mybet-inner
    //- small {{ roomData }}
    //- small {{ betResultFinal }}
    //- result
    template(v-if="[2,3].includes(roomData.room_status)")
      template(v-if="betResultFinal.length > 0 && (betResultFinal[0].position != null && betResultFinal[0].position != 0)")
        template(v-for="bl in betResultFinal")
          .tournament-mybet-single(v-if="bl.position != null && bl.position != 0")
            .tournament-mybet-text.text-dkgreen {{ $t('ui.winner_rank') }} {{ '#' + bl.position }}
            .tournament-mybet-odds
              .tournament-mybet-odds-left
                .tournament-mybet-text.mb-0 {{ bl.currency }} {{ bl.payout }}
              .tournament-mybet-odds-right
                .tournament-mybet-text.mb-0 {{ bl.total_points }} {{ $t('ui.points') }}
            .tournament-mybet-details
              .tournament-mybet-tiny {{ $t('ui.room_id')}}: {{ bl.room_id }}
              .tournament-mybet-tiny.text-success.font-weight-bold(v-if="bl.result_on") {{ $dayjs(bl.result_on).format("MM/DD/YYYY HH:mm A") }}
      template(v-else)
        .tournament-mybet-single
          .empty.d-flex.justify-content-center.align-items-center
            template(v-if="loading.getBetResultFinal")
              i.fad.fa-spinner-third.fa-spin
            template(v-else)
              span {{ $t("message.not_winning_prize_in_this_tournament") }}
    //- mybet
    template(v-if="[0,1,4].includes(roomData.room_status)")
      template(v-if="betList.length > 0")
        .tournament-mybet-single(v-for="(bl, bi) in betList")
          .tournament-mybet-title
            span.badge.badge-light.d-inline.mr-1 {{ bi + 1 }}
            | {{ sportsType[bl.sports_type] }} -  {{ $tc('m.BT_' + bl.bet_type, 1) }}
          .tournament-mybet-status.text-dkgreen(v-if="bl.bet_status") {{ $t('ui.' + bl.bet_status.toLowerCase()) }}
          .tournament-mybet-wrapper
            template(v-if="['HDP','HDPH'].includes(bl.bet_type)")
              .tournament-mybet-small(v-if="bl.home_away === 1") {{ getTeamName("home", bl) }}
              .tournament-mybet-small(v-else) {{ bl.away_team_name }}
            template(v-else)
              .tournament-mybet-small(v-if="bl.home_away === 1") {{ $t('ui.over') }}
              .tournament-mybet-small(v-else) {{ $t('ui.under') }}
            .tournament-mybet-odds
              .tournament-mybet-odds-left
                .tournament-mybet-text.mb-0 {{ bl.ball_display }}
                .tournament-color-red.mx-1 @
                .tournament-mybet-text.mb-0 {{ bl.odds_display }}
              .tournament-mybet-odds-right
                .tournament-mybet-text.mb-0 {{ bl.bet_member }}
            .tournament-mybet-odds
              .tournament-mybet-odds-left
                .tournament-mybet-matches
                  .tn-team {{ getTeamName("home", bl) }}
                  .tn-team {{ getTeamName("away", bl) }}
                  .tn-team.text-dkblue {{ getName("name", bl) }}
              .tournament-mybet-odds-right
                .tournament-mybet-text.mb-0.text-glass
                  span.mr-1.text-glass {{ $t("ui.room") }}:
                  span {{ bl.room_id }}
            .tournament-mybet-details
              .tournament-mybet-tiny.text-orange ID: {{ bl.bet_id }}
              //- .tournament-mybet-status(v-if="bl.bet_status") {{ $t('ui.' + bl.bet_status.toLowerCase()) }}
      template(v-else)
        .tournament-mybet-single
          .empty.d-flex.justify-content-center.align-items-center
            template(v-if="loading.getMemberBetList")
              i.fad.fa-spinner-third.fa-spin
            template(v-else)
              span(v-if="roomData.room_join == 1") {{ $t("message.no_bets") }}
              span(v-else) {{ $t("message.you_did_not_join_this_room") }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import service from "@/views/tournament/library/_xhr.js";

export default {
  props: {
    roomData: {
      type: Object,
    },
  },
  data() {
    return {
      debResult: null,
      debList: null,
      loading: {
        getMemberBetList: false,
        getBetResultFinal: false
      },
      betList: [],
      betResultFinal: [],
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    sportsType() {
      return this.$store.state.layout.sports;
    }
  },
  mounted() {
    this.debResult = this.debounce(this.getBetResultFinal, 250);
    this.debList = this.debounce(this.getMemberBetList, 250);
    this.getData();
  },
  methods: {
    getTeamName(p, e) {
      var name = e[p + "_name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_team_name"];
      }
      return name;
    },
    getName(p, e) {
      var name = e[p + "_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_en"];
      }
      return name;
    },
    debounce(func, wait, immediate) {
      var timeout;

      return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    },
    getData() {
      this.getMemberBetList();
      this.getBetResultFinal();
    },
    getBetResultFinal() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return {};
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getBetResultFinal = true;
      service.betResult(config.tournamentUrl().betresultfinal, json).then(
        (result) => {
          this.loading.getBetResultFinal = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.betResultFinal = result.data.value;
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getBetResultFinal = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getMemberBetList() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return;
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getMemberBetList = true;
      service.memberBetList(config.tournamentUrl().memberbetlist, json).then(
        (result) => {
          this.loading.getMemberBetList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.betList = result.data.value;
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          // console.log(err);
          this.loading.getMemberBetList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
  }
};
</script>